import React from 'react';
import { ReactComponent as Clapping} from './img/clapping.svg';
import { ReactComponent as Desk} from './img/desk.svg';
import { ReactComponent as DevOps} from './img/development-and-progress.svg';
import { ReactComponent as DevOpsAlt} from './img/development.svg';
import { ReactComponent as Dictionary} from './img/dictionary.svg';
import { ReactComponent as Google} from './img/google.svg';
import { ReactComponent as Home} from './img/home.svg';
import { ReactComponent as Library} from './img/library-building.svg';
import { ReactComponent as Link} from './img/link.svg';
import { ReactComponent as ReactLogo} from './img/reactlogo.svg';
import { ReactComponent as Search} from './img/search.svg';
import { ReactComponent as SwaggerAlt} from './img/swagger-alt.svg';
import { ReactComponent as Swagger} from './img/swagger-logo.svg';
import { ReactComponent as UserProfile} from './img/user-profile.svg';
// Should look to speed up lookup by using dictionary object
const CISIcon = props => {   
  var iconName = props.name.toLowerCase();
  var firstLetter = iconName[0];
  switch (firstLetter) {
    case "a":
      switch(iconName) 
      {
        default:
          return <div />;          
      }
    case "b":
    case "c":
      switch(iconName) 
      { 
        case "clapping":
          return <Clapping {...props} />;             
        default:
          return <div />;          
      }     
    case "d":
      switch(iconName) 
      {
        case "desk":
          return <Desk {...props} />;        
        case "devops":
          return <DevOps {...props} />;
        case "devops-alt":
          return <DevOpsAlt {...props} />;      
        case "dictionary":
          return <Dictionary {...props} />;       
        default:
          return <div />;          
      }      
      case "e":
      case "f":
      case "g":  
        switch(iconName) 
        {         
          case "google":
            return <Google {...props} />;                
          default:
            return <div />;          
        }         
      case "h":
      case "i":
      case "j":  
          switch(iconName) 
          {
            case "home":
              return <Home {...props} />;                     
            default:
              return <div />;          
          }             
      case "k":
      case "l":
      case "m":  
          switch(iconName) 
          {
            case "library":
              return <Library {...props} />;     
            case "link":
              return <Link {...props} />;                        
            default:
              return <div />;          
          }      
      case "n":
      case "o":
      case "p":  
      case "q":  
      case "r":  
      case "s":  
          switch(iconName) 
          {             
            case "react-logo":
              return <ReactLogo {...props} />;             
            case "search":
              return <Search {...props} />;                                                                                                 
            case "swagger":
              return <Swagger {...props} />;                          
            case "swagger-alt":
              return <SwaggerAlt {...props} />;                
            default:
              return <div />;          
          }      
      case "t":
      case "u":
      case "v":  
      case "w":  
      case "x":  
      case "y":  
      case "z":        
          switch(iconName) 
          {      
            case "user-profile":
              return <UserProfile {...props} />;                                               
            default:
              return <div />;          
          }  
      default:
        return <div />;      
  }
}
export default CISIcon;